import * as React from 'react';
import clsx from 'clsx';

import Text from '../../../../text/Text.jsx';
import Icon from '../../../../icon/Icon.jsx';

export type SurveyOptionProps = {
  id: string;
  children: React.ReactNode;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'ref'>;

const SurveyOption = ({ id, children, ...props }: SurveyOptionProps) => (
  <label
    className={clsx('survey-option', {
      'survey-option--checked': props.checked
    })}
    htmlFor={id}
  >
    <Text className="survey-option__label" variant="button" tag="div">
      {children}
    </Text>

    <input className="survey-option__input" id={id} {...props} />

    <div className="survey-option__input-check">
      <Icon size="large" id="check" />
    </div>
  </label>
);

export default SurveyOption;
